import Vue from 'vue';
import VueRouter from 'vue-router';

import HomeView from '../views/HomeView.vue';
import AccountView from '../views/AccountView.vue';
import PosView from '../views/PosView.vue';
import PosDetail from '../views/PosDetail.vue';
import TalentPolicy from '../views/TalentPolicy.vue';
import TalentRecommend from '../views/TalentRecommend.vue';
import ListImg from '../views/ListImg.vue';
import DetailView from '../views/DetailView.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/account',
    name: '账号中心',
    component: AccountView,
  },
  {
    path: '/pos',
    name: '职位列表',
    component: PosView,
  },
  {
    path: '/pos-detail',
    name: '职位详情页',
    component: PosDetail,
  },
  {
    path: '/talent-policy',
    name: '人才政策',
    component: TalentPolicy,
  },
  {
    path: '/talent-recommend',
    name: '人才推荐',
    component: TalentRecommend,
  },
  {
    path: '/list-img',
    name: '风采一览',
    component: ListImg,
  },
  {
    path: '/detail',
    name: '文章详情页',
    component: DetailView,
  },
  {
    path: '*',
    name: '404',
    redirect: '/',
  }
];

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { x: 0, y: 0 };
  }
}

const router = new VueRouter({
  routes,
  scrollBehavior,
});

export default router;
